import { config } from "../config";

export const getTagValue = (tags, key) => {
  if (Array.isArray(tags)) {
    const item = tags.find((entry) => entry.Key === key);
    return item ? item.Value : "";
  } else if (typeof tags === "object" && tags !== null) {
    return tags[key] || "";
  }
  return "";
};

export const createTags = (nameParts, envName, projName, platformName) => {
  const updatedBy = `${nameParts[0]} ${nameParts[1]}`;

  if (platformName !== config.platforms[0]) {
    return {
      Environment: envName,
      Project: projName,
      CreatedBy: updatedBy,
      UpdatedBy: updatedBy,
    };
  }

  return [
    { Key: "Environment", Value: envName },
    { Key: "Project", Value: projName },
    { Key: "CreatedBy", Value: updatedBy },
    { Key: "UpdatedBy", Value: updatedBy },
  ];
};

export const setTagValue = (tags, key, value, platformName) => {
  if (platformName !== config.platforms[0]) {
    return { ...tags, [key]: value };
  }

  const existing = Array.isArray(tags) ? tags : [];
  const idx = existing.findIndex((tag) => tag.Key === key);
  if (idx === -1) {
    return [...existing, { Key: key, Value: value }];
  }
  return existing.map((tag, i) => (i === idx ? { ...tag, Value: value } : tag));
};

export const updateTagsWithUser = (tags, nameParts, platformName) => {
  const updatedBy = `${nameParts[0]} ${nameParts[1]}`;

  if (platformName !== config.platforms[0]) {
    return { ...tags, UpdatedBy: updatedBy };
  }

  const newTags = tags.map((tag) =>
    tag.Key === "UpdatedBy" ? { ...tag, Value: updatedBy } : tag
  );

  if (!newTags.find((tag) => tag.Key === "UpdatedBy")) {
    newTags.push({ Key: "UpdatedBy", Value: updatedBy });
  }

  return newTags;
};

export const validateJson = (jsonString) => {
  try {
    JSON.parse(jsonString);
    return true;
  } catch (error) {
    return false;
  }
};
